<template>
	<div class="full" style="background-color: white;">
		<el-container class="full">
			<el-aside width="250px" style="border-right: 1px solid #DCDFE6;">
				<emun-tree :field="name" ref="emuntTree" :key="emuntTreeKey" @select="emuntTreeChange" />
			</el-aside>
			<el-container class="full flex"
				style="position: relative;flex-direction: column;box-sizing: border-box;padding: 20px;">
				<el-header class="bread" style="position: relative;height: 30px;">
					<el-breadcrumb separator-class="el-icon-arrow-right" v-if="parentbread.length!=0">
						<el-breadcrumb-item v-for="(item,index) in parentbread" :key="index">{{item.name}}
						</el-breadcrumb-item>
					</el-breadcrumb>
					<div v-else>请选择城市</div>
				</el-header>
				<el-main style="flex: 1;position: relative;">

					<el-tabs v-model="activeName" type="card" >
						<el-tab-pane label="仓库优先级" name="priority">
							<priority :currentitem="currentitem" :emunid="emunid" />
						</el-tab-pane>
						<el-tab-pane label="编码管理" name="code">
							<codeIndex :currentitem="currentitem" :emunid="emunid" />
						</el-tab-pane>
					</el-tabs>






				</el-main>
			</el-container>
		</el-container>
	</div>

</template>
<style scoped>
	.bread {
		flex-direction: column;
		align-items: center;
		justify-content: center;

	}
</style>
<script>
	import emunTree from '@_system/components/formcomponents/common/select/emun/tree.vue'
	import priority from './priority/index.vue'
	import codeIndex from './code/index.vue'
	export default {
		name: 'emunextend_cityIndex',
		props: {
			name: {
				default: () => {
					return ''
				}
			},
		},
		data() {
			return {
				activeName:'priority',
				loading: false,
				currentitem: null,
				emunid: 0,
				emuntTreeKey: Math.random(),
				parentbread: [],

			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			emuntTreeChange(e) {
				this.currentitem = e
				this.emunid = e.id
				this.parentbread = e.parentbread
			},
		},
		components: {
			emunTree,
			priority,
			codeIndex
		}
	}
</script>
